// A visit status's tag colour and label key, shared by every place that shows one.
export const visitStatusColor = (status?: string | null): string => {
  switch (status?.toLowerCase()) {
    case 'scheduled':
      return 'blue';
    case 'in_progress':
      return 'processing';
    case 'completed':
      return 'success';
    case 'cancelled':
      return 'error';
    default:
      return 'default';
  }
};

export const visitStatusLabelKey = (status?: string | null): string =>
  `visits-status-${String(status || '')
    .toLowerCase()
    .replace(/_/g, '-')}`;
